import React, { useState } from 'react';
import {
  IconButton,
  Paper,
  Typography,
  InputBase,
  Divider,
  Box
} from '@mui/material';
import {
  Add as AddIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import SwipeableViews from 'react-swipeable-views';
import { observer } from 'mobx-react-lite';

import axios from '../../lib/axios';
import useStores from '../../stores/useStores';
import AccountList from './AccountList';
import AccountSettings from './AccountSettings';

function AccountManager({ accounts, onSelectAccount }) {
  const [activeStep, setActiveStep] = useState(0);
  const [account, setAccount] = useState(null);
  const [filterBy, setFilterBy] = useState('');
  const { userStore, modalStore, projectStore } = useStores();

  const handleStepChange = step => {
    setActiveStep(step);
  };

  const filterAccounts = (accounts, filterBy) => {
    return accounts.filter(account =>
      account.name.toLowerCase().includes(filterBy.toLowerCase())
    );
  };

  const handleChange = e => {
    setFilterBy(e.target.value);
  };

  const handleGroupAdd = async () => {
    const { data } = await axios.post('/group', {
      name: 'New Group'
    });

    const groupId = data.data.id;
    await userStore.switchGroup(groupId);
    projectStore.fetchAll();
    modalStore.setModal(null);
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        flexGrow: 1
      }}
    >
      <Paper
        square
        elevation={0}
        sx={{
          alignItems: 'center',
          paddingLeft: 2,
          display: 'flex'
        }}
      >
        {activeStep === 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '96%'
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}
            >
              <Typography>Select Account</Typography>
              {userStore.user.is_admin && (
                <IconButton
                  id="nav-group-add"
                  onClick={() => {
                    handleGroupAdd();
                  }}
                  component="span"
                  size="large"
                >
                  <AddIcon />
                </IconButton>
              )}
            </div>
          </div>
        )}

        {activeStep === 1 && (
          <>
            <IconButton
              style={{ marginLeft: -14 }}
              onClick={() => {
                setActiveStep(0);
                setAccount(null);
              }}
              color="primary"
              component="span"
              size="large"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography>Account settings</Typography>
          </>
        )}
      </Paper>
      <SwipeableViews
        disabled
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        <div
          style={{
            maxHeight: 360,
            scrollbarWidth: 'thin'
          }}
          key="list"
        >
          <Divider className="search-controls-divider" />

          <div
            style={{
              marginTop: 10,
              paddingLeft: 16,
              alignItems: 'center',
              width: '100%'
            }}
          >
            <InputBase onChange={handleChange} placeholder="Search..." />
          </div>
          <AccountList
            accounts={filterBy ? filterAccounts(accounts, filterBy) : accounts}
            onSelectAccount={onSelectAccount}
            onClickSettings={account => {
              setAccount(account);
              setActiveStep(1);
            }}
          />
        </div>
        <div key="settings">
          <Paper
            style={{
              minWidth: 400,
              minHeight: 370
            }}
            square
            elevation={0}
          >
            {account && (
              <AccountSettings
                onDelete={() => {
                  setActiveStep(0);
                  setAccount(null);
                }}
                account={account}
              />
            )}
          </Paper>
        </div>
      </SwipeableViews>
    </Box>
  );
}

export default observer(AccountManager);
